// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.widget {
  display: block;
  position: relative;
  margin-bottom: 30px;
  padding: var(--widget-padding-y) var(--widget-padding-x);
  background: var(--widget-bg);

  
}

.title {
  margin-top: 0;
  margin-bottom: calc(1.5rem / 2);
  color: var(--widget-title-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/Widget/Widget.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wDAAwD;EACxD,4BAA4B;;;AAG9B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gCAAgC;AAClC","sourcesContent":["\n.widget {\n  display: block;\n  position: relative;\n  margin-bottom: 30px;\n  padding: var(--widget-padding-y) var(--widget-padding-x);\n  background: var(--widget-bg);\n\n  \n}\n\n.title {\n  margin-top: 0;\n  margin-bottom: calc(1.5rem / 2);\n  color: var(--widget-title-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
